import { render, staticRenderFns } from "./subscription-category-card.vue?vue&type=template&id=ca459164&scoped=true&"
import script from "./subscription-category-card.ts?vue&type=script&lang=ts&"
export * from "./subscription-category-card.ts?vue&type=script&lang=ts&"
import style0 from "./subscription-category-card.scss?vue&type=style&index=0&id=ca459164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca459164",
  null
  
)

export default component.exports